import { Typography } from '@mui/material';

type Props = {
  label: string;
  values: string[];
  isSubtext?: boolean;
};

export default function SectionTextRow({ label, values, isSubtext }: Props) {
  return (
    <div className="section-row">
      {label && (
        <Typography variant="overline" component="p">
          {label}
        </Typography>
      )}
      {values.map((value, index) => (
        <Typography
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          variant={isSubtext ? 'caption' : 'body2'}
          color={isSubtext ? 'text.secondary' : undefined}
          whiteSpace="pre-line">
          {value}
        </Typography>
      ))}
    </div>
  );
}
